import { getGeoIpCountryCode } from './geoIpLookup';

export const GLOBAL_FLIPDISH_SIGN_UP_URL = 'https://www.flipdish.com/sign-up';

export const FLIPDISH_SIGN_UP_URLS = {
  ES: 'https://www.flipdish.com/es/sign-up',
  GB: 'https://www.flipdish.com/gb/sign-up',
  IE: 'https://www.flipdish.com/ie/sign-up',
  US: 'https://www.flipdish.com/us/sign-up',
} as const;

export type SupportedFlipdishSignUpCountryCode = keyof typeof FLIPDISH_SIGN_UP_URLS;

const normalizeCountryCode = (countryCode?: string): string | undefined =>
  countryCode?.trim().toUpperCase() || undefined;

export const getSupportedFlipdishSignUpCountryCode = (
  countryCode?: string
): SupportedFlipdishSignUpCountryCode | undefined => {
  const normalizedCountryCode = normalizeCountryCode(countryCode);

  if (normalizedCountryCode && normalizedCountryCode in FLIPDISH_SIGN_UP_URLS) {
    return normalizedCountryCode as SupportedFlipdishSignUpCountryCode;
  }

  return undefined;
};

export const getLocaleCountryCode = (
  languageCode?: string
): SupportedFlipdishSignUpCountryCode | undefined => {
  const normalizedLanguageCode = languageCode?.trim().replace(/_/g, '-').toLowerCase();

  if (!normalizedLanguageCode) {
    return undefined;
  }

  if (normalizedLanguageCode === 'es' || normalizedLanguageCode === 'es-es') {
    return 'ES';
  }

  if (normalizedLanguageCode === 'en-ie') {
    return 'IE';
  }

  if (normalizedLanguageCode === 'en-gb') {
    return 'GB';
  }

  if (normalizedLanguageCode === 'en-us') {
    return 'US';
  }

  return undefined;
};

export const getFlipdishSignUpUrl = (countryCode?: string): string => {
  const supportedCountryCode = getSupportedFlipdishSignUpCountryCode(countryCode);

  if (!supportedCountryCode) {
    return GLOBAL_FLIPDISH_SIGN_UP_URL;
  }

  return FLIPDISH_SIGN_UP_URLS[supportedCountryCode];
};

export const resolveContactSalesCountryCode = async (
  languageCode?: string
): Promise<SupportedFlipdishSignUpCountryCode | undefined> => {
  try {
    const geoIpCountryCode = await getGeoIpCountryCode();
    const supportedGeoIpCountryCode = getSupportedFlipdishSignUpCountryCode(geoIpCountryCode);

    if (supportedGeoIpCountryCode) {
      return supportedGeoIpCountryCode;
    }
  } catch {
    // Fall back to locale when GeoIP lookup fails.
  }

  return getLocaleCountryCode(languageCode);
};

export const resolveContactSalesSignUpUrl = async (languageCode?: string): Promise<string> => {
  const countryCode = await resolveContactSalesCountryCode(languageCode);

  return getFlipdishSignUpUrl(countryCode);
};
